import { render, staticRenderFns } from "./RecordsView.vue?vue&type=template&id=4dcc23fe&scoped=true"
import script from "./RecordsView.vue?vue&type=script&lang=js"
export * from "./RecordsView.vue?vue&type=script&lang=js"
import style0 from "./RecordsView.vue?vue&type=style&index=0&id=4dcc23fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcc23fe",
  null
  
)

export default component.exports